<template>
	<div v-html="slider"></div>
</template>

<script>
export default {
	data() {
		return {};
	},

	props: {
		slider: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: {},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import "../../styles/common/variables";

/* write SCSS here */
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/SmartSlider.vue